export const getEmailBeforeDog = emailStr => {
  return emailStr.slice(0, Math.max(0, emailStr.indexOf("@")))
}
